<template>
  <a
    :href="`https://ruba.jobs.personio.de/job/${position.id}?language=de_CH`"
    target="_blank"
    class="job-posting"
  >
    <h3 class="name">{{ position.name }}</h3>
    <p class="employment-type">{{ employmentTypeAndSchedule }}</p>
    <p class="location">{{ locationLabel }}</p>
    <p class="employment-type-location">
      {{ employmentTypeAndSchedule }} - {{ locationLabel }}
    </p>
  </a>
</template>

<script setup lang="ts">
import type { JobPosition } from '~/types/jobsList.types';
import { formatEmploymentTypeOption } from '~/utils/jobs/employmentTypeFilter';
import { formatScheduleOption } from '~/utils/jobs/scheduleFilter';

const props = defineProps<{
  position: JobPosition;
}>();

const employmentTypeLabel = computed(() =>
  formatEmploymentTypeOption(props.position.employmentType)
);
const scheduleLabel = computed(() =>
  props.position.schedule ? formatScheduleOption(props.position.schedule) : ''
);
const employmentTypeAndSchedule = computed(() =>
  scheduleLabel.value
    ? `${employmentTypeLabel.value} · ${scheduleLabel.value}`
    : employmentTypeLabel.value
);
const locationLabel = computed(
  () => props.position.locationLabel ?? props.position.office
);
</script>

<style scoped lang="scss">
.job-posting {
  grid-column: 1 / span 4;
  box-shadow: 0 1px 0 0 var(--color-grey);

  display: grid;
  grid-template-columns: subgrid;
  padding: 2rem 0rem;
  text-decoration: none;

  &:first-child {
    border-top: 1px solid var(--color-grey);
  }

  @media (--vs) {
    grid-template-columns: 1fr;
    padding: 1rem 0;

    > .name {
      grid-column: 1 / span 2;
    }
    > .type-location {
      grid-column: 1 / span 2;
      color: var(--base-color-foreground-faded);
    }
  }

  &:hover {
    box-shadow: 0 2px 0 0 var(--color-black);
  }

  > .name {
    @include text-lg(600);
    grid-column: 1 / span 2;

    @media (--vs) {
      @include text-md(600);
      grid-column: 1 / span 1;
    }
  }
  > .employment-type {
    @include text-md(300);
    grid-column: 3 / span 1;
    color: var(--base-color-foreground-faded);
    @media (--vs) {
      display: none;
    }
  }
  > .location {
    @include text-md(300);
    text-align: right;
    grid-column: 4 / span 1;
    color: var(--base-color-foreground-faded);
    @media (--vs) {
      display: none;
    }
  }
  > .employment-type-location {
    padding-top: 0.5rem;
    @include text-sm(300);
    grid-column: 1 / span 1;
    color: var(--base-color-foreground-faded);
    display: none;
    @media (--vs) {
      display: block;
    }
  }
}
</style>
